/**
 * PÁGINA DE PREÇOS - GROWLY
 * Mostra planos disponíveis e integra com Stripe
 */

import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PricingPage = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      const response = await fetch('https://growly-test-production.up.railway.app/api/payments/plans');
      const data = await response.json();

      if (data.success) {
        console.log('✅ Planos carregados:', data.plans);
        setPlans(data.plans);
      }
    } catch (error) {
      console.error('Erro ao carregar planos:', error);
    }
  };

  const handleSubscribe = async (plan) => {
    console.log('🛒 Iniciando checkout para plano:', plan);
    
    setLoading(true);
    setSelectedPlan(plan.id);

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        alert('Faça login para assinar um plano');
        setLoading(false);
        setSelectedPlan(null);
        window.location.href = '/login';
        return;
      }

      console.log('📦 Enviando requisição com:', {
        planId: plan.id,
        priceId: plan.priceId
      });

      const response = await fetch('https://growly-test-production.up.railway.app/api/payments/create-checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ 
          planId: plan.id,
          priceId: plan.priceId
        })
      });

      console.log('📡 Status da resposta:', response.status);

      const data = await response.json();
      console.log('📥 Resposta do servidor:', data);

      if (data.success && data.url) {
        console.log('✅ Redirecionando para:', data.url);
        window.location.href = data.url;
      } else {
        console.error('❌ Erro na resposta:', data);
        alert('Erro: ' + (data.error || 'Falha ao criar checkout'));
      }
    } catch (error) {
      console.error('❌ Erro ao criar checkout:', error);
      alert('Erro ao processar pagamento: ' + error.message);
    } finally {
      setLoading(false);
      setSelectedPlan(null);
    }
  };

  return (
    <div className="pricing-page">
      <div className="pricing-header">
        <h1>Escolha seu plano</h1>
        <p>Cancele quando quiser • Sem taxa de setup • Primeira semana grátis</p>
      </div>

      <div className="pricing-grid">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`pricing-card ${plan.id === 'growth' ? 'featured' : ''}`}
          >
            {plan.id === 'growth' && (
              <div className="popular-badge">MAIS POPULAR</div>
            )}

            <h3>{plan.name}</h3>
            <div className="price">
              <span className="currency">R$</span>
              <span className="amount">{(plan.price / 100).toFixed(0)}</span>
              <span className="period">/mês</span>
            </div>

            <ul className="features">
              {plan.features.map((feature, index) => (
                <li key={index}>✓ {feature}</li>
              ))}
            </ul>

            <button
              onClick={() => handleSubscribe(plan)}
              disabled={loading && selectedPlan === plan.id}
              className="subscribe-btn"
            >
              {loading && selectedPlan === plan.id ? 'Processando...' : 'Começar agora'}
            </button>

            {/* Debug info - remover depois */}
            {process.env.NODE_ENV === 'development' && (
              <small style={{display: 'block', marginTop: '10px', fontSize: '10px', color: '#666'}}>
                Price ID: {plan.priceId}
              </small>
            )}
          </div>
        ))}
      </div>

      <div className="pricing-footer">
        <p>
          💳 Pagamento 100% seguro via Stripe<br />
          🔒 Dados protegidos com SSL<br />
          📞 Suporte especializado
        </p>
      </div>
    </div>
  );
};

export default PricingPage;